import React from "react";
import Tooltip from "../RankingTooltips/RankingTooltipContainer";
import {connect} from "react-redux";

const TutorialTooltip = ({children, language}) => {
    if (language !== 'nl') {
        return <div>{children}</div>;
    }

    return <Tooltip id="tutorial">{children}</Tooltip>
};

export default connect((state, ownProps) => ({
    language: state.user.language,
    ...ownProps
}))(TutorialTooltip)